import React from "react";

const ComplianceSection = ({ complianceItems }) => {
  return (
    <section className="compliance-section py-5">
      <div className="container text-center">
        <h2 className="fw-bold text-dark mb-5">Compliance</h2>
        <div className="row justify-content-center">
          {complianceItems.map((item, index) => (
            <div className="col-12 col-md-4 mb-4" key={index}>
              <div className="compliance-icon-circle mb-3">
                <i className={`bi ${item.icon}`}></i>
              </div>
              <p className="compliance-label fw-semibold mt-3 mb-0">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;
